<div class="task-head">
  <h4 style="text-align: center;">Please Note</h4>
</div>
<p style="padding-top: 25px;text-align: center;">
    Please note that once you create the task, you cannot cancel it, as the task will be ordered with the next available pass. <br>
    We will embargo an additional {{data.opticalValue}} for optical and {{data.sarValue}} for SAR,
    {{data.stereoValue}} for Stereo, {{data.hsiValue}} for HSI and {{data.videoValue}} for Video sensors <br>
    additionally to cover any real-time cost updates from the operators. Any unused amount would be returned to your account after the automatic ordering.<br>
    The task will be rejected if there are insufficient funds.
  </p>
  
  <div class="btns" fxLayoutAlign="center center" fxLayout="row" style="padding-bottom: 10px;">
    <button mat-stroked-button (click)="onNoClick()" style="width: 120px;">I do not agree</button>
    <button mat-stroked-button (click)="onAgreeClick()" style="margin-left: 13px !important; width: 120px;" class="submit" >
      I agree
    </button>
  </div>
